import { useState } from "react";
import { candidates, newCandidateColors1, newCandidateColors2 } from "../consts";
import { Candidate } from "../types";
import _ from "lodash";

export default function CandidateSelector({startDebate}: {startDebate: (candidates: Candidate[]) => void;}) {
  const [selectedCandidates, setSelectedCandidates] = useState<Candidate[]>([]);
  const [allCandidates, setAllCandidates] = useState<Candidate[]>(candidates);

  const toggleCandidate = (candidate: Candidate) => {
    if ((selectedCandidates.indexOf(candidate) === -1 && selectedCandidates.length !== 2) || selectedCandidates.indexOf(candidate) !== -1) {
      const newSelectedCandidates = _.xor(selectedCandidates, [candidate]);
      setSelectedCandidates(newSelectedCandidates);
    }
  }
  
  const getCandidateStyle = (candidate: Candidate) => {
    if (selectedCandidates.indexOf(candidate) !== -1) {
      return `transition ease-in ${candidate.styles.default} text-white border-white`;
    }
    return `transition ease-in hover:${candidate.styles.hover} hover:text-white hover:border-white`
  }

  const getButtonStyle = () => {
    if (selectedCandidates.length === 2) {
      return "transition ease-in bg-sky-50 text-sky-600 hover:bg-sky-100 hover:text-sky-700 px-4";
    } else {
      return "bg-gray-200 text-gray-500 px-4";
    }
  }

  const addCandidate = () => {
    const inputElement = document.getElementById("new-candidate") as HTMLInputElement;
    const newCandidate: Candidate = {
      name: inputElement.value,
      styles: selectedCandidates.length === 0 ? newCandidateColors1 : newCandidateColors2,
    };
    const newCandidatesList = allCandidates.concat(newCandidate);
    const newSelectedList = selectedCandidates.concat(newCandidate);

    setAllCandidates(newCandidatesList);
    setSelectedCandidates(newSelectedList);

    inputElement.value = "";
  }

  return (
    <div className="container md:mt-0 md:m-auto h-screen flex md:items-center md:justify-center md:max-w-[784px]">
      <div className="flex flex-col justify-between md:justify-start md:gap-10 px-1 md:px-4 lg:px-0">
        <div className="flex flex-col text-center md:text-start pt-8">
          <div className="text-blue-500 font-semibold text-5xl">Presidential Debate 2024</div>
          <div className="text-blue-500 font-semibold text-xl">Simulated by AI</div>
        </div>

        <div className="flex flex-col gap-4 items-center md:items-start">
          <div className={`text-slate-600 px-0 flex items-center w-fit rounded-lg font-medium whitespace-nowrap focus:outline-none cursor-pointer`}>
            {selectedCandidates.length === 2 ? "2 candidates selected" : 
              selectedCandidates.length === 1 ? "1 candidate selected" : "Select 2 candidates"}
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-3 justify-center md:justify-start">
            {allCandidates.map((candidate => {
              return (
                <div
                  key={candidate.name}
                  className={`${getCandidateStyle(candidate)} w-28 h-[104px] md:w-36 md:h-32 border border-gray-400 rounded-lg flex items-center justify-center cursor-pointer font-medium text-center p-1 md:text-lg`}
                  onClick={() => toggleCandidate(candidate)}
                >
                  {candidate.name}
                </div>
              )}
            ))}
          </div>

          <div className="mt-6 flex flex-col gap-2 md:flex-row md:items-center">
            <div className="text-slate-600 font-medium">Create your own:</div>
            <div className="flex gap-2 items-center">
              <input id="new-candidate" className="rounded h-8 border-gray-500 focus:ring-0 focus:outline-none focus:border-gray-500" disabled={selectedCandidates.length === 2} />
              <button
                className={`h-9 flex items-center rounded-lg font-medium text-sm px-3 focus:outline-none ${selectedCandidates.length === 2 ? "bg-gray-200 text-gray-500" : "bg-sky-50 text-sky-600 hover:bg-sky-100 hover:text-sky-700 "}`}
                onClick={() => addCandidate()}
                disabled={selectedCandidates.length === 2}
              >
                Add
              </button>
            </div>
          </div>

          <div className="mt-2 w-full flex justify-center">
            <button
              className={`${getButtonStyle()} h-14 flex items-center w-fit rounded-lg font-medium whitespace-nowrap focus:outline-none cursor-pointer text-xl`}
              onClick={() => startDebate(selectedCandidates)}
            >
              
              Debate!
            </button>
          </div>
        </div>

        <div className="md:mt-[-12px] italic text-gray-400 font-semibold text-xs p-3 md:p-0">For legal reasons: responses are generated by AI and not the actual candidates. This is meant to be an open playground for AI and simulate mock debates between candidates who may never see the stage against each other. Some responses can be used to learn candidate's viewpoints on various issues, but it is worth fact-checking the responses.</div>
      </div>
    </div>
  )
}